import { useState, useEffect } from 'react'
import { updatePage } from '../../../../actions/requests'
import { setShowEmojiModal } from '../../../../actions/ui'

export const useModerationForm = (page, userAttributes, dispatch, moderationForm) => {
  const [emojiList, setEmojiList] = useState(page.details.attributes.emoji_list)
  const [emojiSel, setEmojiSel] = useState()
  const [showDeleteModeModal, setShowDeleteModeModal] = useState(false)
  const [loadingButtons, setLoadingButtons] = useState(new Set())

  const pageAttributes = page.details.attributes

  const setButtonLoading = (buttonId, isLoading) => {
    setLoadingButtons(prev => {
      const newSet = new Set(prev)
      if (isLoading) {
        newSet.add(buttonId)
      } else {
        newSet.delete(buttonId)
      }
      return newSet
    })
  }

  const handleChange = (e, option_name= null) => {
    // Determine which button was clicked based on the event target
    let buttonId = 'default'
    
    // Check if the button has a specific button ID set
    if (e.target.dataset && e.target.dataset.buttonId) {
      buttonId = e.target.dataset.buttonId
    } else if (e.target.name === 'button' && e.target.className.includes('save-blacklist')) {
      // Fallback: Find the closest form field to determine which section this save button belongs to
      const form = e.target.form
      if (form) {
        // Check for specific form fields to determine the button context
        if (form.querySelector('#hide_negativity_context')) {
          buttonId = 'hide_negativity_context'
        } else if (form.querySelector('#hide_urls_list')) {
          buttonId = 'hide_urls_list'
        } else if (form.querySelector('#hide_mentions_list')) {
          buttonId = 'hide_mentions_list'
        } else if (form.querySelector('#hide_hashtags_list')) {
          buttonId = 'hide_hashtags_list'
        } else if (form.querySelector('#emoji_list')) {
          buttonId = 'emoji_list'
        } else if (form.querySelector('#tag-list')) {
          buttonId = 'tag-list'
        } else if (form.querySelector('#page\\[whitelist\\]')) {
          buttonId = 'page[whitelist]'
        }
      }
    } else {
      // For other form elements, use their name or id
      buttonId = e.target.name || e.target.id || 'default'
    }
    
    setButtonLoading(buttonId, true)
    
    const formData = new FormData(e.target.form)
    const checkboxes = document.querySelectorAll("input[type=checkbox]")
    Array.from(checkboxes).forEach(checkbox => {
      formData.append(checkbox.name, checkbox.checked)
    })

    // Handle blacklist tags
    if (pageAttributes.blacklist) {
      const tagList = document.getElementById("tag-list")
      formData.append("page[tags]", tagList.value)
    }

    // Handle emoji settings
    const emojiOptionEl = document.getElementById("page[emoji_option]")
    const emojiListEl = document.getElementById("emoji_list")
    if (pageAttributes.hide_emojis) {
      formData.append("page[emoji_option]", emojiOptionEl.value)
      formData.append("page[emoji_list]", emojiListEl ? emojiListEl.value : "")
    } else {
      formData.append("page[emoji_option]", "any")
      formData.append("page[emoji_list]", "")
    }

    const ml_option = document.getElementById("page[moderation_limit_option]")
    if (pageAttributes.moderation_limit) {
      formData.append("page[moderation_limit_option]", ml_option.value)
    } else {
      formData.append("page[moderation_limit_option]", 'ads_and_posts')
    }

    // Handle URL settings
    if (e.target.id === "page[hide_urls]" && !e.target.checked) {
      const hideUrlsAdv = document.getElementById("hide_urls_advanced")
      const whitelistEl = document.getElementById("page[whitelist]")
      hideUrlsAdv && (hideUrlsAdv.checked = false)
      formData.append("page[hide_urls_list]", "")
      formData.append("page[hide_urls_advanced]", false)
      whitelistEl && !whitelistEl.value && formData.append("page[whitelist]", "")
    }

    if (e.target.id === "page[hide_negative_sentiment]" && !e.target.checked) {
      const hideNcAdv = document.getElementById("hide_negativity_advanced")
      hideNcAdv && (hideNcAdv.checked = false)
      formData.append("page[hide_negativity_context]", "")
      formData.append("page[hide_negativity_advanced]", false)
    }

    // Handle whitelist
    if (pageAttributes.private_mode) {
      const whitelistEl = document.getElementById("page[whitelist]")
      whitelistEl && formData.append("page[whitelist]", whitelistEl.value)
    }

    if (pageAttributes.hide_urls) {
      const hideUrlsList = document.getElementById("hide_urls_list")
      hideUrlsList && formData.append("page[hide_urls_list]", hideUrlsList.value)
    }

    // Handle mentions settings
    if (e.target.id === "page[hide_mentions]" && !e.target.checked) {
      const hideMentionsAdv = document.getElementById("hide_mentions_advanced")
      hideMentionsAdv && (hideMentionsAdv.checked = false)
      formData.append("page[hide_mentions_list]", "")
      formData.append("page[hide_mentions_advanced]", false)
    }

    if (pageAttributes.hide_mentions) {
      const hideMentionsList = document.getElementById("hide_mentions_list")
      hideMentionsList && formData.append("page[hide_mentions_list]", hideMentionsList.value)
    }

    // Handle hashtags settings
    if (e.target.id === "page[hide_hashtags]" && !e.target.checked) {
      const hideHashtagsAdv = document.getElementById("hide_hashtags_advanced")
      hideHashtagsAdv && (hideHashtagsAdv.checked = false)
      formData.append("page[hide_hashtags_list]", "")
      formData.append("page[hide_hashtags_advanced]", false)
    }

    if (pageAttributes.hide_hashtags) {
      const hideHashtagsList = document.getElementById("hide_hashtags_list")
      hideHashtagsList && formData.append("page[hide_hashtags_list]", hideHashtagsList.value)
    }

    // Handle custom AI filter description
    if (buttonId === 'custom_ai_filter_desc') {
      // The form data should already contain the custom_ai_filter_desc[] entries
      // from the saveCustomAiFilter function in the component
    }


    // Handle custom AI filter toggle - clear inputs when disabled
    if (e.target.id === "page[custom_ai_filter]") {
      if(!e.target.checked){
        formData.append("page[custom_ai_filter_desc][]", "")
      }else{
        pageAttributes.custom_ai_filter_desc.forEach((input) => {
          formData.append('page[custom_ai_filter_desc][]', input.trim())
        })
      }
    }


    setShowDeleteModeModal(false)
    
    if(option_name){
      formData.append(`page[${option_name}_advanced]`, true)
    }

    dispatch(updatePage(page.details.id, formData, false, ()=>setButtonLoading(buttonId, false)))
  }

  const handleEmojiSelect = (emoji) => {
    setEmojiSel(emoji.native)
  }

  const clickOutsideEmoji = (e) => {
    if (!e.target.classList.contains("emoji-icon") && 
        e.target.localName !== "path" && 
        e.target.localName !== "em-emoji-picker") {
      dispatch(setShowEmojiModal(false))
    }
  }

  const enableAdvancedOption = (e, option_name) => {
    e.preventDefault()
    handleChange(e, option_name)

    // const formData = new FormData(e.target.form)
    // formData.append(`page[${option_name}_advanced]`, true)
    // dispatch(updatePage(page.details.id, formData))
  }

  const closeDeleteModeModal = () => {
    setShowDeleteModeModal(false)
  }

  const deleteModeModal = () => {
    setShowDeleteModeModal(true)
  }

  const deleteModeHandler = (e) => {
    if (pageAttributes.delete_mode) {
      handleChange(e)
    } else {
      setShowDeleteModeModal(true)
    }
  }

  const handleDeleteMode = (e) => {
    e.preventDefault()
    const formData = new FormData(e.target.form)
    formData.append(`page[delete_mode]`, true)
    dispatch(updatePage(page.details.id, formData))
    setShowDeleteModeModal(false)
  }

  return {
    pageAttributes,
    userAttributes,
    emojiList,
    emojiSel,
    showDeleteModeModal,
    handleChange,
    handleEmojiSelect,
    clickOutsideEmoji,
    enableAdvancedOption,
    closeDeleteModeModal,
    deleteModeModal,
    deleteModeHandler,
    handleDeleteMode,
    setEmojiList,
    setEmojiSel,
    setShowDeleteModeModal,
    loadingButtons,
    setButtonLoading
  }
} 